import { t } from 'i18next';

import { IUserSubscriptionResponse, SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

import { formatDate } from './formatDates';

export const getToastSuccessContent = ({ currentSubscription, nextSubscription }: IUserSubscriptionResponse) => {
  const areSubscriptionPlansSame: boolean = currentSubscription.subscriptionPlan === nextSubscription.subscriptionPlan;
  const isNextPlanPaid: boolean = nextSubscription.subscriptionPlan !== SUBSCRIPTION_PLAN.FREE;
  const formattedEndDate: string = formatDate(currentSubscription.endDate);
  const currentSubscriptionPlan: string = currentSubscription.subscriptionPlan.toLocaleLowerCase();
  const currentSubscriptionRecurrent: string = currentSubscription.recurrent?.toLocaleLowerCase() ?? '';
  const nextSubscriptionPlan: string = nextSubscription.subscriptionPlan.toLocaleLowerCase();
  const nextSubscriptionRecurrent: string = nextSubscription.recurrent?.toLocaleLowerCase() ?? '';
  const text: string = t('yourSubscriptionWillBeCanceled', {
    date: formattedEndDate,
    subscription: t(currentSubscriptionPlan),
  });

  if (areSubscriptionPlansSame) {
    return {
      title: t('yourRecurrentSubscriptionCanceled', {
        subscription: t(currentSubscriptionPlan),
        recurrent: t(currentSubscriptionRecurrent),
      }),
      text: t('yourRecurrentSubscriptionStarts', {
        subscription: t(nextSubscriptionPlan),
        recurrent: t(nextSubscriptionRecurrent),
      }),
    };
  }

  if (!areSubscriptionPlansSame && isNextPlanPaid) {
    return {
      title: t('youHaveSuccessFullySubscribedTo', {
        subscription: t(nextSubscriptionPlan),
      }),
      text,
    };
  }

  return {
    title: t('youHaveSuccessFullyUnsubscribed'),
    text,
  };
};
